function isDeviceTypeMobile() {
    const ua = navigator.userAgent;
    if (
        /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)
    ) {
        return true;
    }
    return false;
}

export default isDeviceTypeMobile;
